import React, { useState, useCallback, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import NotFound from '../../common/404';
import { deleteOntotis, getOntotisSingle, updateOntotis } from '../../../utils/apicall/ontotisApi';
import { Ontotis, OntotisDropDown, Unit } from '../../../utils/types';
import { getOntotisDropDown, getUnitsDropDown } from '../../../utils/apicall/commonApi';
import { DefaultOntotis } from '../../../utils/data';
import GeneralErrorPage from '../../common/general-error';
import { handleError, ApiError } from '../../../utils/error/error';
import { processError } from '../../../utils/error/errorUtils';
import ErrorMessage from '../../../components/errorMessage';
import DeleteConfirmationModal from '../../../components/DeleteConfirmationModal';
import SuccessAlert from '../../../components/SuccessAlert';
import { CONFIG } from '../../../utils/config';
import { authService } from '../../../utils/authServices';
import TextEditor from '../../../components/TextEditor';

const OntotitaEdit: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const [isValidId, setIsValidId] = useState(true);
    const [data, setData] = useState<Ontotis | null>(null);
    const [ontotisDropDown, setOntotisDropDown] = useState<OntotisDropDown[]>([]);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [errors, setErrors] = useState<{ [key: string]: string[] }>({});
    const [successMessage, setSuccessMessage] = useState<string | null>(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const navigate = useNavigate(); // Initialize useNavigate
    const location = useLocation();
    const [formData, setFormData] = useState({
        id: null,
        title: '',
        parent_id: null,
        description: '',
        subontotisname: '',
        address: '',
        city: '',
        postalCode: '',
        phone1: '',
        phone2: '',
        email: '',
        unit_id: null,
        customorder: 0,
      });

    const [units, setUnits] = useState<Unit[]>([]);

    useEffect(() => {
        // Check if ID is valid and is a number
        if (!id || isNaN(Number(id))) {
            setIsValidId(false);
        }
    }, [id]);

    const loadData = useCallback(async () => {
        if (isValidId) {
            try {
                const response = await getOntotisSingle(parseInt(id!, 10));
               // console.log(response);
                if (response) {
                    setData(response);
                    setFormData(response);
                  //  console.log(response);
                   // console.log(response);
                }
            } catch (error) {
                handleError(error);
                    if (error instanceof ApiError && error.statusCode === 404) {
                    return <NotFound />;
                    } else {
                        console.error('An unexpected error occurred:', error);
                        return <GeneralErrorPage />;
                    }
                }
            }
    }, [id, isValidId]);

    const loadUnits = useCallback(async () => {
        try {
            const response = await getUnitsDropDown();
            if (response) {
                setUnits(response);
            }
        } catch (error) {
            handleError(error);
            if (error instanceof ApiError && error.statusCode === 404) {
            return <NotFound />;
            } else {
                console.error('An unexpected error occurred:', error);
                return <GeneralErrorPage />;
            }
}
    }, []);
    const loadOntotisDropDown = useCallback(async () => {
        try {
            const response = await getOntotisDropDown();
           // console.log({ response });
            if (response) {
                setOntotisDropDown(response);
               // console.log(response);
            } else {
                console.warn('Expected an array but got:', response);
            }
        } catch (error) {
            handleError(error);
            if (error instanceof ApiError && error.statusCode === 404) {
            return <NotFound />;
            } else {
                console.error('An unexpected error occurred:', error);
                return <GeneralErrorPage />;
            }
}
    }, []);

    useEffect(() => {
        loadUnits();
        loadOntotisDropDown();
    }, [loadUnits, loadOntotisDropDown]);

    useEffect(() => {
        loadData();
        
       authService.refreshAuthToken();
    }, [loadData]);

    if (!isValidId) {
        return <NotFound />;
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        if (name=="parent_id"){
//console.log(value);
        }
        // Ensure we are updating the formData only with Ontotis fields
        setFormData(prevData => ({
            ...prevData,
            [name]: name === 'parent_id' || name === 'unit_id' || name === 'customorder' ? parseInt(value, 10) || null : value
        }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setSuccessMessage(null);
        setErrorMessage(null);
        const returnTo = location.state?.returnTo || "-1";
        if (!formData || !id) return; // Ensure formData and id are available

        try {
      
            const updatedData = await updateOntotis(parseInt(id, 10), formData);
            setSuccessMessage('Η οντότητα ενημερώθηκε με επιτυχία!'); // Custom success message
           
            setTimeout(() => {
                // Go back to the previous page and pass a `refresh` flag
               // navigate(returnTo, { state: { refresh: true } });
              }, 800); // Adjust delay if necessary*/
             
            
        } catch (error) {
           // alert("Η ενημέρωση απέτυχε. Δοκιμάστε ξανά.");
            handleError(error);
            processError(error, setErrors, setErrorMessage, setSuccessMessage);
            if (error instanceof ApiError && error.statusCode === 404) {
                return <NotFound />;
            } else {
                console.error('An unexpected error occurred:', error);
                return <GeneralErrorPage />;
            }
           
        }
    };


    const handleDelete = async () => {
        if (!id) return;
        const returnToDel = location.state?.returnToDel || "-1";
           setShowDeleteModal(false); // Close the modal after confirming
        try {
            await deleteOntotis(parseInt(id, 10));
           
            setSuccessMessage('Η οντότητα διαγράφηκε με επιτυχία!'); // Custom success message
           // setShowSuccessAlert(true); // Show success alert
           setTimeout(() => {
            // Go back to the previous page and pass a `refresh` flag
            navigate(returnToDel, { state: { refresh: true } });
          }, 800); // Adjust delay if necessary*/
         
    
           
        } catch (error) {
            handleError(error);
            processError(error, setErrors, setErrorMessage, setSuccessMessage);
        }
    };

   
    const handleChangeTextEditor = (field: string) => (content: string) => {
        setFormData((prev) => ({
          ...prev,
          [field]: content,
        }));
      };



    return (
        <div className="content">
              {/* Success Alert 
             {showSuccessAlert && (
                <SuccessAlert
                    message={successMessage!} // Dynamic success message
                    onClose={() => setShowSuccessAlert(false)}
                />
            )}*/}
            <section className="ontotita py-5">
                <div className="container mt-4">
                    <div className="card p-5">
                        <h2 className="h5 mb-2 text-primary">
                            Επεξεργασία Οντότητας: <span className="text-secondary"> {formData?.title}</span>
                        </h2>
                        <hr />
                        <form className="mt-2" onSubmit={handleSubmit}>
                        {successMessage && (
                            <div className="alert alert-success alert-dismissible fade show" role="alert">
                                <strong></strong> {successMessage}
                                <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="alert"
                                aria-label="Close"
                                ></button>
                            </div>
                            )}
                            {errorMessage && (
                            <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                <strong></strong> {errorMessage}
                                <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="alert"
                                aria-label="Close"
                                ></button>
                            </div>
                            )}

                       {/*<!-- Γονική Οντότητα και Τίτλος Οντότητας -->*/} 
                        <div className="row mb-3">
                            <div className="mb-3">
                                <label htmlFor="unit_id" className="form-label">Περιφερειακή Ενότητα</label>
                                <div className="input-group">
                                    <span className="input-group-text"><i className="bi bi-geo-fill"></i></span>
                                    <select
                                        id="unit_id"
                                        name="unit_id"
                                        className="form-select"
                                        required
                                        value={formData?.unit_id || ""}
                                        onChange={handleChange}
                                    >
                                        <option value="">Επιλέξτε Περιφερειακή Ενότητα</option>
                                        {units.map(unit => (
                                            <option key={unit.id} value={unit.id}>
                                                {unit.title}
                                            </option>
                                        ))}
                                    </select>
                                  
                                </div>
                                {errors && errors.hasOwnProperty('unit_id') && (<ErrorMessage message={errors.unit_id[0]} />)}
                            </div>

                              {/* Γονική Οντότητα */}
                    <div className="col-md-6">
                            <label htmlFor="parent_id" className="form-label">Γονική Οντότητα</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="bi bi-diagram-3"></i></span>
                                {/* <select
                                    id="parent_id"
                                    name="parent_id"
                                    className="form-select"
                                    value={formData.parent_id || ""} // Ensure formData.parent_id is used as the value
                                    onChange={handleChange}
                                >
                                    <option value="">Επιλέξτε Γονική Οντότητα</option>
                                   {ontotisDropDown.map(item => (
                                        <option key={item.id} value={item.id} disabled={item.id === parseInt(id!)}>
                                            {item.title}
                                        </option>
                                    ))} 
                                </select>*/}
                                        <select
                                            id="parent_id"
                                            name="parent_id"
                                            className="form-select"
                                            value={formData.parent_id || ''} // Ensure controlled component behavior
                                            onChange={handleChange}
                                        >
                                            <option value="">Επιλέξτε Γονική Οντότητα</option>
                                            {ontotisDropDown.map((item) => (
                                                <option 
                                                    key={item.id} 
                                                    value={item.id} 
                                                    disabled={!item.can_edit} // Disable if can_edit is false
                                                >
                                                    {item.title}
                                                </option>
                                            ))}
                                        </select>
                               
                            </div>
                            {errors && errors.hasOwnProperty('parent_id') && (<ErrorMessage message={errors.parent_id[0]} />)}
                        </div>
                          {/* Τίτλος Οντότητας */}
                          <div className="col-md-6">
                              <label htmlFor="title" className="form-label">Τίτλος Οντότητας</label>
                              <div className="input-group">
                                  <span className="input-group-text"><i className="bi bi-card-text"></i></span>
                                
                                  <input
                                      type="text"
                                      id="title"
                                      name="title"
                                      className="form-control"
                                      required
                                      value={formData?.title || ""}
                                      onChange={handleChange}
                                  />
                                  
                              </div>
                              {errors && errors.hasOwnProperty('title') && (<ErrorMessage message={errors.title[0]} />)}
                          </div>
                        </div>
                          {/* Περιγραφή */}
                          <div className="mb-3">
                              <label htmlFor="description" className="form-label">Περιγραφή</label>
                              <TextEditor value={formData?.description || ""} onChange={handleChangeTextEditor("description")}/>
                            {/*    <textarea
                                  id="description"
                                  name="description"
                                  className="form-control"
                                  rows={3}
                                  value={formData?.description || ""}
                                  onChange={handleChange}
                              ></textarea>*/}
                               {errors && errors.hasOwnProperty('description') && (<ErrorMessage message={errors.description[0]} />)}
                          </div>

                          {/* Όνομα Υπό-οντοτήτων and Ταξινόμηση */}
                          <div className="row mb-3">
                              <div className="col-md-6">
                                  <label htmlFor="subontotisname" className="form-label">Όνομα Υπό-οντοτήτων</label>
                                  <div className="input-group">
                                        <span className="input-group-text"><i className="bi bi-bookmark"></i></span>
                                        <input
                                            type="text"
                                            id="subontotisname"
                                            name="subontotisname"
                                            className="form-control"
                                            value={formData?.subontotisname || ""}
                                            onChange={handleChange}
                                        />
                                       
                                  </div>
                                  {errors && errors.hasOwnProperty('subontotisname') && (<ErrorMessage message={errors.subontotisname[0]} />)}
                              </div>
                              <div className="col-md-6">
                                  <label htmlFor="customorder" className="form-label">Ορισμός Ταξινόμησης</label>
                                  <div className="input-group">
                                    <span className="input-group-text"><i className="bi bi-sort-alpha-down"></i></span>
                                    <input
                                        type="number"
                                        id="customorder"
                                        name="customorder"
                                        className="form-control"
                                        value={formData?.customorder || 0}
                                        onChange={handleChange}
                                    />
                                    
                                   </div>
                                   {errors && errors.hasOwnProperty('customorder') && (<ErrorMessage message={errors.customorder[0]} />)}
                              </div>
                          </div>

                          {/* Διεύθυνση */}
                          <div className="row mb-3">
                              <div className="col-md-6">
                                  <label htmlFor="address" className="form-label">Διεύθυνση</label>
                                  <div className="input-group">
                                      <span className="input-group-text"><i className="bi bi-geo-alt"></i></span>
                                      <input
                                          type="text"
                                          id="address"
                                          name="address"
                                          className="form-control"
                                          value={formData?.address || ""}
                                          onChange={handleChange}
                                      />
                                     
                                  </div>
                                  {errors && errors.hasOwnProperty('address') && (<ErrorMessage message={errors.address[0]} />)}
                              </div>

                              {/* Πόλη */}
                              <div className="col-md-4">
                                  <label htmlFor="city" className="form-label">Πόλη</label>
                                  <div className="input-group">
                                      <span className="input-group-text"><i className="bi bi-building"></i></span>
                                      <input
                                          type="text"
                                          id="city"
                                          name="city"
                                          className="form-control"
                                          value={formData?.city || ""}
                                          onChange={handleChange}
                                      />
                                     
                                  </div>
                                  {errors && errors.hasOwnProperty('city') && (<ErrorMessage message={errors.city[0]} />)}
                              </div>

                              {/* ΤΚ */}
                              <div className="col-md-2">
                                  <label htmlFor="postalCode" className="form-label">ΤΚ</label>
                                  <div className="input-group">
                                      <span className="input-group-text"><i className="bi bi-envelope"></i></span>
                                      <input
                                          type="text"
                                          id="postalCode"
                                          name="postalCode"
                                          className="form-control"
                                          value={formData?.postalCode || ""}
                                          onChange={handleChange}
                                      />
                                       
                                  </div>
                                  {errors && errors.hasOwnProperty('postalCode') && (<ErrorMessage message={errors.postalCode[0]} />)}
                              </div>
                          </div>

                          {/* Τηλέφωνα */}
                          <div className="row mb-3">
                              <div className="col-md-6">
                                  <label htmlFor="phone1" className="form-label">Τηλέφωνο 1</label>
                                  <div className="input-group">
                                      <span className="input-group-text"><i className="bi bi-telephone"></i></span>
                                      <input
                                          type="text"
                                          id="phone1"
                                          name="phone1"
                                          className="form-control"
                                          value={formData?.phone1 || ""}
                                          onChange={handleChange}
                                      />
                                     
                                  </div>
                                  {errors && errors.hasOwnProperty('phone1') && (<ErrorMessage message={errors.phone1[0]} />)}
                              </div>

                              <div className="col-md-6">
                                  <label htmlFor="phone2" className="form-label">Τηλέφωνο 2</label>
                                  <div className="input-group">
                                      <span className="input-group-text"><i className="bi bi-telephone"></i></span>
                                      <input
                                          type="text"
                                          id="phone2"
                                          name="phone2"
                                          className="form-control"
                                          value={formData?.phone2 || ""}
                                          onChange={handleChange}
                                      />
                                      
                                  </div>
                                  {errors && errors.hasOwnProperty('phone2') && (<ErrorMessage message={errors.phone2[0]} />)}
                              </div>
                          </div>

                          {/* Email */}
                          <div className="mb-3">
                              <label htmlFor="email" className="form-label">Email</label>
                              <div className="input-group">
                                  <span className="input-group-text"><i className="bi bi-envelope"></i></span>
                                  <input
                                      type="email"
                                      id="email"
                                      name="email"
                                      className="form-control"
                                      value={formData?.email || ""}
                                      onChange={handleChange}
                                  />
                               
                              </div>
                              {errors && errors.hasOwnProperty('email') && (<ErrorMessage message={errors.email[0]} />)}
                          </div>

                          {/* Submit Button */}
                          <div className="text-end mt-4">
                              <button type="submit" className="btn btn-primary">
                                  <i className="bi bi-save"></i> Αποθήκευση
                              </button>
                              <button type="button" className="btn btn-danger ms-2"   onClick={() => setShowDeleteModal(true)}>
                                <i className="bi bi-trash me-1"></i> Διαγραφή
                            </button>
                            {/* Delete Confirmation Modal */}
                            <DeleteConfirmationModal
                                show={showDeleteModal}
                                onConfirm={handleDelete}
                                onCancel={() => setShowDeleteModal(false)} // Just close the modal
                                title="Επιβεβαίωση Διαγραφής"
                                message="Αυτή η ενέργεια θα διαγράψει οριστικά την επιλεγμένη οντότητα. Είστε βέβαιοι;"
                                confirmText="Ναι, Διαγραφή"
                                cancelText="Ακύρωση"
                            />
                          </div>
                      </form>

                   
                    </div>
                </div>
            </section>
        </div>
    );
};

export default OntotitaEdit;

